import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { apiRequest } from "../../utils/utils";

const SubscriptionLink = (props) => {
  const [url, setUrl] = useState("");
  const { data } = props;
  const inputRef = useRef(null);

  const getData = async (data) => {
    const postData = {
      studio_id: data && data.customer_id,
      user_id: data && data.customer_user_uuid,
    };

    let crmStagingUrl = process.env.REACT_APP_CRM + "/classic/customer-details";
    let responseData;
    try {
      responseData = await apiRequest(crmStagingUrl, "POST", postData);
      console.log("Response:", responseData);
    } catch (error) {
      console.error("Error:", error);
    }

    if (responseData) {
      setUrl(
        responseData.studio_id &&
          responseData.studio_id.uniqid &&
          responseData.studio_id.uniqid
      );
    } else {
      console.warn("Something went wrong in  Subscription Link");
    }
  };

  useEffect(() => {
    if (data && data.customer_id) {
      getData(data);
    }
  }, [data && data.customer_id]);

  const copy = () => {
    const input = document.getElementById("inputLink");
    // Check if the input element exists
    if (!input) {
      console.error("Input element not found");
      return;
    }
    // Select the input text
    input.select();
    try {
      // Copy the selected text to the clipboard
      document.execCommand("copy");
      //console.log("Text copied:", input.value);
    } catch (err) {
      console.error("Unable to copy text:", err);
    }
  };
  return (
    <Modal show={props.show} onHide={props.close}>
      <Modal.Header>
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div class="form-group">
            <input
              type="text"
              className="form-control"
              id="inputLink"
              ref={inputRef}
              value={`https://www.muvi.com/signup/purchaseSubscription.html?studio=${url}`}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            type="button"
            variant="dark"
            className="btn-dark-btn"
            onClick={props.close}
          >
            Close
          </Button>
          <Button type="button" variant="primary" onClick={copy}>
            Copy
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SubscriptionLink;



// WEBPACK FOOTER //
// ./src/components/childcomponents/SubscriptionLink.js